
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
   
    listFormRaporByFormId(formId){
       return $axios.get('FormRapor/listFormRaporByFormId/'+formId);
    },
    save(formRapor){
               return $axios.post('FormRapor',formRapor);
    },

      delete(formRaporId) {
        return $axios.delete('/FormRapor/'+formRaporId);
  
      }
  };